(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["pc-offer-block"] && !Shopify.designMode) return;
  try {
    class PcOfferBlock extends HTMLElement {
  constructor() {
   super();
   this.state = { tier: 1, qty: 1, fixingMethod: 'screws', ledOn: false };
  }
  connectedCallback() {
   const d = this.dataset;
   const addon = this.querySelector('.pc-offer__addon');
   this.cfg = {
    panelPrice:    parseInt(d.panelPrice, 10) || 0,
    panelVariantId:  parseInt(d.panelVariantId, 10) || 0,
    screwsVariantId:  parseInt(d.screwsVariantId, 10) || 0,
    screwsPrice:    parseInt(d.screwsPrice, 10) || 0,
    adhesiveVariantId: parseInt(d.adhesiveVariantId, 10) || 0,
    adhesivePrice:   parseInt(d.adhesivePrice, 10) || 0,
    screwsPerPanel:  parseInt(d.screwsPerPanel, 10) || 16,
    screwsPerPack:   parseInt(d.screwsPerPack, 10) || 100,
    panelsPerTube:   parseInt(d.panelsPerTube, 10) || 3,
    ledVariantId:   addon ? (parseInt(addon.dataset.pcLedVariantId, 10) || 0) : 0,
    ledPrice:     addon ? (parseInt(addon.dataset.pcLedPrice, 10) || 0) : 0,
   };
   // Default to whichever fixing method is actually available.
   if (!this.cfg.screwsVariantId && this.cfg.adhesiveVariantId) this.state.fixingMethod = 'adhesive';
   this._bind();
   this._calcAndRender();
  }

  _bind() {
   this.querySelectorAll('[data-pc-tier-radio]').forEach(r => {
    r.addEventListener('change', () => {
     if (r.checked) {
      this.state.tier = parseInt(r.value, 10);
      this._setActiveTier();
      this._calcAndRender();
     }
    });
   });

   const qtyInput = this.querySelector('[data-pc-qty-input]');
   const qtyDec  = this.querySelector('[data-pc-qty-dec]');
   const qtyInc  = this.querySelector('[data-pc-qty-inc]');
   if (qtyDec) qtyDec.addEventListener('click', () => this._setQty(this.state.qty - 1));
   if (qtyInc) qtyInc.addEventListener('click', () => this._setQty(this.state.qty + 1));
   if (qtyInput) qtyInput.addEventListener('change', () => this._setQty(parseInt(qtyInput.value, 10) || 1));

   this.querySelectorAll('[name^="fixing-method-"]').forEach(r => {
    r.addEventListener('change', () => {
     if (r.checked) { this.state.fixingMethod = r.value; this._calcAndRender(); }
    });
   });

   const ledToggle = this.querySelector('[data-pc-led-toggle]');
   if (ledToggle) ledToggle.addEventListener('change', () => {
    this.state.ledOn = ledToggle.checked;
    this._calcAndRender();
   });

   const atc = this.querySelector('[data-pc-offer-atc]');
   if (atc) atc.addEventListener('click', (e) => this._handleAtc(e));

   this._setActiveTier();
  }

  _setActiveTier() {
   this.querySelectorAll('.pc-offer-tier').forEach(card => {
    card.dataset.pcTierActive = (parseInt(card.dataset.pcTier, 10) === this.state.tier) ? 'true' : 'false';
   });
  }

  _setQty(n) {
   n = Math.max(1, Math.min(999, n || 1));
   this.state.qty = n;
   const inp = this.querySelector('[data-pc-qty-input]');
   if (inp) inp.value = n;
   this._calcAndRender();
  }

  // Fixing units (screw packs OR adhesive tubes) needed for `qty` panels.
  _fixingUnits(method, qty) {
   if (method === 'adhesive') return Math.ceil(qty / this.cfg.panelsPerTube);
   return Math.ceil((qty * this.cfg.screwsPerPanel) / this.cfg.screwsPerPack);
  }
  _fixingUnitPrice(method) {
   return method === 'adhesive' ? this.cfg.adhesivePrice : this.cfg.screwsPrice;
  }
  _fixingCost(method, qty) {
   if (method === 'adhesive' && !this.cfg.adhesiveVariantId) return 0;
   if (method === 'screws'  && !this.cfg.screwsVariantId)  return 0;
   return this._fixingUnits(method, qty) * this._fixingUnitPrice(method);
  }
  // LED add-on: one strip per panel (auto-matched length). Costs only when toggled on.
  _ledQty(qty) { return qty; }
  _ledCost(qty) { return (this.state.ledOn && this.cfg.ledVariantId) ? this.cfg.ledPrice * this._ledQty(qty) : 0; }
  // Headline "from" price for a tier = the panel price (both tiers). The fixing is
  // shown separately on its own line, so it is NOT rolled into the headline.
  _tierUnit(tier) { return this.cfg.panelPrice; }
  _fixingLabel(method) { return method === 'adhesive' ? 'Adhesive' : 'Screws'; }
  // Live tier total for `qty` panels (panels + pack-rounded fixings). LED added at grand total.
  _tierTotal(tier, qty) {
   let p = this.cfg.panelPrice * qty;
   if (tier >= 2) p += this._fixingCost(this.state.fixingMethod, qty);
   return p;
  }
  _calcAndRender() {
   const qty = this.state.qty;
   this.querySelectorAll('.pc-offer-tier').forEach(card => {
    const tier  = parseInt(card.dataset.pcTier, 10);
    const unitEl = card.querySelector('[data-pc-tier-price]');
    const totalEl = card.querySelector('[data-pc-tier-total]');
    const fixEl  = card.querySelector('[data-pc-tier-fixing]');
    const combEl = card.querySelector('[data-pc-tier-combined]');
    const method = this.state.fixingMethod;
    // Headline = panel price each. Panel subtotal line only appears when buying
    // more than one (at qty 1 it just repeats the headline).
    if (unitEl) unitEl.textContent = this._formatMoney(this._tierUnit(tier));
    if (totalEl) totalEl.textContent = qty > 1 ? (qty + ' panels · ' + this._formatMoney(this.cfg.panelPrice * qty)) : '';
    // Tier 2 only: the chosen fixing's cost, then the combined panels + fixing total.
    if (fixEl) fixEl.textContent = '+ ' + this._fixingLabel(method) + ' · ' + this._formatMoney(this._fixingCost(method, qty));
    if (combEl) combEl.textContent = 'Panels + ' + this._fixingLabel(method).toLowerCase() + ': ' + this._formatMoney(this._tierTotal(2, qty));
   });
   // LED add-on price line reflects the current panel qty (one strip per panel).
   const addonPriceEl = this.querySelector('[data-pc-addon-price]');
   if (addonPriceEl && this.cfg.ledVariantId) {
    addonPriceEl.textContent = '+ ' + this._formatMoney(this.cfg.ledPrice * this._ledQty(qty));
   }
   const totalEl = this.querySelector('[data-pc-total-amount]');
   if (totalEl) totalEl.textContent = this._formatMoney(this._tierTotal(this.state.tier, qty) + this._ledCost(qty));
  }

  _formatMoney(cents) {
   const amount = (cents / 100).toFixed(2);
   const [int, dec] = amount.split('.');
   const intWithCommas = int.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
   return `$${intWithCommas}.${dec}`;
  }

  async _handleAtc(e) {
   e.preventDefault();
   this._setState('loading', '');
   const qty = this.state.qty;
   const items = [];
   items.push({ id: this.cfg.panelVariantId, quantity: qty });
   if (this.state.tier >= 2) {
    const method = this.state.fixingMethod;
    const fixId = method === 'adhesive' ? this.cfg.adhesiveVariantId : this.cfg.screwsVariantId;
    const units = this._fixingUnits(method, qty);
    if (fixId && units > 0) items.push({ id: fixId, quantity: units });
   }
   if (this.state.ledOn && this.cfg.ledVariantId) {
    items.push({ id: this.cfg.ledVariantId, quantity: this._ledQty(qty) });
   }

   try {
    const res = await fetch('/cart/add.js', {
     method: 'POST',
     headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
     body: JSON.stringify({ items })
    });
    if (!res.ok) {
     const data = await res.json().catch(() => ({}));
     throw new Error(data.description || 'Could not add to cart');
    }
    this._setState('success', 'Added to cart.');
    document.dispatchEvent(new CustomEvent('cart:update'));
    document.dispatchEvent(new CustomEvent('cart:refresh'));
   } catch (err) {
    this._setState('error', err.message || 'Could not add to cart. Please try again.');
   }
  }

  _setState(state, message) {
   this.dataset.pcState = state || '';
   const status = this.querySelector('[data-pc-offer-status]');
   if (!status) return;
   if (message) {
    status.textContent = message;
    status.hidden = false;
   } else {
    status.hidden = true;
    status.textContent = '';
   }
  }
 }

 if (!customElements.get('pc-offer-block')) {
  customElements.define('pc-offer-block', PcOfferBlock);
 }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["pc-pdp-cta"] && !Shopify.designMode) return;
  try {
    (function () {
  function bind() {
   document.querySelectorAll('[data-pc-pdp-cta]').forEach(function (btn) {
    if (btn._pcBound) return; btn._pcBound = true;
    btn.addEventListener('click', function (e) {
     var target = document.getElementById('pc-buy');
     if (!target) return; // native href="#pc-buy" fallback
     e.preventDefault();
     target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
   });
  }
  if (document.readyState !== 'loading') bind(); else document.addEventListener('DOMContentLoaded', bind);
 })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["pc-pdp-details"] && !Shopify.designMode) return;
  try {
    class PcTabs extends HTMLElement {
  connectedCallback() {
   this._panels = Array.from(this.querySelectorAll('[data-pc-panel]'));
   if (!this._panels.length) return;
   this.querySelectorAll('.pc-tab-mtrigger').forEach((trig) => {
    trig.addEventListener('click', () => this.toggle(trig.dataset.pcTab));
   });
  }
  panelFor(name) { return this._panels.find((p) => p && p.dataset.pcPanel === name); }
  setOpen(panel, open) {
   if (!panel) return;
   panel.classList.toggle('is-active', open);
   const trig = panel.querySelector('.pc-tab-mtrigger');
   if (trig) trig.setAttribute('aria-expanded', open ? 'true' : 'false');
  }
  toggle(name) {
   const panel = this.panelFor(name);
   if (panel) this.setOpen(panel, !panel.classList.contains('is-active'));
  }
 }
 if (!customElements.get('pc-tabs')) { customElements.define('pc-tabs', PcTabs); }

 // Detailed install guide lightbox (delegated, so it works for any instance).
 (function () {
  if (window.__pcGuideBound) return; window.__pcGuideBound = true;
  function setOpen(g, open) {
   if (!g) return;
   g.classList.toggle('is-open', open);
   g.setAttribute('aria-hidden', open ? 'false' : 'true');
   document.body.classList.toggle('pc-guide-open', open);
  }
  document.addEventListener('click', function (e) {
   var openBtn = e.target.closest('[data-pc-guide-open]');
   if (openBtn) {
    // Guide is a sibling of <pc-tabs> (outside the tab panels). Look in the shared parent.
    var wrap = openBtn.closest('pc-tabs');
    var scope = (wrap && wrap.parentElement) || document;
    setOpen(scope.querySelector('[data-pc-guide]') || document.querySelector('[data-pc-guide]'), true);
    return;
   }
   var closeBtn = e.target.closest('[data-pc-guide-close]');
   if (closeBtn) setOpen(closeBtn.closest('[data-pc-guide]'), false);
  });
  document.addEventListener('keydown', function (e) {
   if (e.key !== 'Escape') return;
   var open = document.querySelector('[data-pc-guide].is-open');
   if (open) setOpen(open, false);
  });
 })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["pc-pdp-size-picker"] && !Shopify.designMode) return;
  try {
    class PcSizePicker extends HTMLElement {
  connectedCallback() {
   if (this.dataset.pcMulti !== 'true') return;
   this.querySelectorAll('[data-pc-size-radio]').forEach((r) => {
    r.addEventListener('change', () => this._handleChange(r));
   });
  }
  _handleChange(radio) {
   if (!radio || !radio.checked) return;
   const url = new URL(window.location.href);
   url.searchParams.set('variant', radio.value);
   window.location.href = url.toString();
  }
 }
 if (!customElements.get('pc-size-picker')) {
  customElements.define('pc-size-picker', PcSizePicker);
 }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["pc-ugc-reel"] && !Shopify.designMode) return;
  try {
    class PcUgcCarousel extends HTMLElement {
    connectedCallback() {
      this._track  = this.querySelector('[data-pc-ugc-track]');
      this._cards  = Array.from(this.querySelectorAll('[data-pc-ugc-card]'));
      this._prev   = this.querySelector('[data-pc-ugc-prev]');
      this._next   = this.querySelector('[data-pc-ugc-next]');
      if (!this._track || !this._cards.length) return;

      this._cards.forEach((card) => {
        const playBtn = card.querySelector('[data-pc-ugc-play]');
        const video   = card.querySelector('[data-pc-ugc-video]');
        const media   = card.querySelector('.pc-ugc-card__media');
        if (!media) return;

        const togglePlay = (e) => {
          if (e) { e.preventDefault(); e.stopPropagation(); }
          if (!video) return;
          if (card.classList.contains('is-playing')) {
            video.pause();
          } else {
            this.playOnly(card);
          }
        };

        if (playBtn) playBtn.addEventListener('click', togglePlay);
        media.addEventListener('click', togglePlay);

        if (video) {
          video.addEventListener('play',  () => card.classList.add('is-playing'));
          video.addEventListener('pause', () => card.classList.remove('is-playing'));
          video.addEventListener('ended', () => card.classList.remove('is-playing'));
        }
      });

      const scrollByCard = (dir) => {
        const card = this._cards[0];
        if (!card) return;
        const step = card.getBoundingClientRect().width + 16;
        this._track.scrollBy({ left: dir * step, behavior: 'smooth' });
      };
      if (this._prev) this._prev.addEventListener('click', () => scrollByCard(-1));
      if (this._next) this._next.addEventListener('click', () => scrollByCard(1));

      const updateNavVisibility = () => {
        const { scrollLeft, scrollWidth, clientWidth } = this._track;
        const atStart = scrollLeft <= 2;
        const atEnd   = scrollLeft + clientWidth >= scrollWidth - 2;
        if (this._prev) this._prev.hidden = atStart;
        if (this._next) this._next.hidden = atEnd;
      };
      this._track.addEventListener('scroll', updateNavVisibility, { passive: true });
      window.addEventListener('resize', updateNavVisibility, { passive: true });
      requestAnimationFrame(updateNavVisibility);
    }

    playOnly(card) {
      this._cards.forEach((c) => {
        const v = c.querySelector('[data-pc-ugc-video]');
        if (!v) return;
        if (c === card) {
          v.play().catch(() => { });
        } else {
          v.pause();
          c.classList.remove('is-playing');
        }
      });
    }
  }
  if (!customElements.get('pc-ugc-carousel')) {
    customElements.define('pc-ugc-carousel', PcUgcCarousel);
  }
  } catch(e) { console.error(e); }
})();

})();
